import axios from "axios";
import { gatherListRequest } from "./gatherListRequest";

/// GET THE CATALOG ITEMS /////////////////////////////
export const catalogData = async (user) => {
  const { body, axiosConfig } = gatherListRequest(user);

  try {
    const res = await axios.post("/api/ms1/", body, axiosConfig);
    if (!Array.isArray(res.data)) {
      throw new Error("Catalog list response was not an array.");
    }
    return res.data;
  } catch (err) {
    console.log(
      "%cERROR:",
      "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
      err
    );
    throw err;
  }
};

/// GET ONE CATALOG ITEM /////////////////////////////
export const getQuestionBy_Id = async (user, question_Id) => {
  let axiosConfig = null;

  if (user) {
    axiosConfig = {
      headers: {
        "Content-Type": "text/plain",
        Authorization: "JWT " + user.token,
      },
      timeout: 60000,
    };
  }

  const res = await axios.post(
    "/api/ms1/" + question_Id,
    gatherListRequest(user).body,
    axiosConfig,
  );
  return res.data;
};

/// SAVE ONE /////////////////////////////////////
export async function addDocToDB(userAndDataObject) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + userAndDataObject.user.token,
    },
  };

  const response = await axios
    .post(`/api/ms1/add/`, userAndDataObject, axiosConfig)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(
        "%cERROR:",
        "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
        err
      );
      return err;
    });
  return response;
}

/// SAVE MANY /////////////////////////////////
export async function saveManyCatalogItems(userAndDataObject) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + userAndDataObject.user.token,
    },
  };

  const response = await axios
    .post(`/api/ms1/add-many/`, userAndDataObject, axiosConfig)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(
        "%cERROR:",
        "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
        err
      );
      return err;
    });
  return response;
}

/// PATCH (exact keys only — never injects preReleaseMessage) /////
export function buildCatalogPatchBody(id, dataObj) {
  const payload =
    dataObj && typeof dataObj === "object" ? { ...dataObj } : {};
  payload.identifier = id;
  return payload;
}

export async function patchACatalogItem(id, dataObj, user) {
  const payload = buildCatalogPatchBody(id, dataObj);
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + user.token,
    },
  };
  try {
    return await axios.post(`/api/ms1/update/`, { dataObj: payload }, axiosConfig);
  } catch (err) {
    console.log(
      "%cERROR:",
      "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
      err,
    );
    return err;
  }
}

/// UPDATE //////////////////////////////////
export async function updateACatalogItem(id, dataObj, user) {
  // Keep a plain payload; never mutate caller state by accident
  const payload = {
    ...dataObj,
    identifier: id,
  };
  // Guarantee pre-release copy is present on the wire (including empty string)
  if (!Object.prototype.hasOwnProperty.call(payload, "preReleaseMessage")) {
    payload.preReleaseMessage = "";
  } else if (payload.preReleaseMessage == null) {
    payload.preReleaseMessage = "";
  } else {
    payload.preReleaseMessage = String(payload.preReleaseMessage);
  }

  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    console.log(
      "%cupdateACatalogItem preReleaseMessage:",
      "color:#fff;background:#287094;padding:4px 8px;border-radius:0 12px 12px 0",
      payload.preReleaseMessage,
    );
  }

  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + user.token,
    },
  };

  const response = await axios
    .post(`/api/ms1/update/`, { dataObj: payload }, axiosConfig)
    .then((res) => {
      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        console.log(
          "%cupdateACatalogItem response doc.preReleaseMessage:",
          "color:#fff;background:#007215;padding:4px 8px;border-radius:0 12px 12px 0",
          res?.data?.doc?.preReleaseMessage,
        );
      }
      return res;
    })
    .catch((err) => {
      console.log(
        "%cERROR:",
        "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
        err
      );

      return err;
    });
  return response;
}

/// DELETE ////////////////////////////////
export async function deleteDocFromDb(id, user) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + user.token,
    },
  };
  const response = await axios
    .get(`/api/ms1/${id}/delete/`, axiosConfig)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(
        "%cERROR:",
        "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
        err
      );
      return err;
    });
  return response;
}

/// DELETE ALL ///////////////////////////
export async function deleteAllQuestions(user) {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + user.token,
    },
  };
  const response = await axios
    .get(`/api/ms1/deleteAll/`, axiosConfig)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(
        "%cERROR:",
        "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
        err
      );
      console.log(
        "%cERROR:",
        "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
        err
      );
      return err;
    });
  return response;
}

/// GET CATALOG ITEM SCHEMA //////////////
export async function getSchemaForCatalogItem() {
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const output = await axios
    .get(`/api/ms1/model/`, axiosConfig)
    .then((res) => {
      return res.data.model;
    })
    .catch((err) => {
      const output = { response: { request: {} } };
      console.log(
        "%cERROR:",
        "color:#f0f0ef;background:#ff0000;padding:32px;border-radius:0 25px 25px 0",
        err
      );

      if (err.code && err.code === "ERR_NETWORK") {
        output.response.status = 500;
        output.response.statusText = err.message;
        output.response.request.responseURL = err.config.baseURL;
      }
      return output.response;
    });

  return output;
}
